import { render } from "./myPageView.vue?vue&type=template&id=2d69a41f"
import script from "./myPageView.vue?vue&type=script&lang=js"
export * from "./myPageView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__